<template>
  <div>
    <el-card class="top-tool">
      <el-dropdown
        trigger="click"
        style="margin: 5px 0; flex-shrink: 0"
        @command="handleCommand"
      >
        <span class="el-dropdown-link">
          <i class="el-icon-edit-outline"></i>
          {{ myStatus == 1 ? "我的待办" : "我的已办" }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">我的待办</el-dropdown-item>
          <el-dropdown-item command="2">我的已办</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <i
        class="el-icon-arrow-left"
        style="margin-left: 50px; margin-right: 10px; cursor: pointer"
        v-if="scrollFlag"
        @click="moveScroll(1)"
      ></i>
      <div :class="['project-list', { ml50: !scrollFlag }]" ref="scrollBar">
        <template v-for="(item, index) in projectList">
          <div
            :class="[
              'project-item',
              { highLight: currentProject === item.projectId },
            ]"
            :key="index"
            @click="getCurrentProject(item), test"
          >
            • {{ item.projectName }}（{{ item.relateNum }}）
          </div>
        </template>
        <!-- <template>
          <div class="project-item" v-for="o in 10" :key="o">asda把那就开始打sd{{o}}</div>
        </template> -->
      </div>
      <i
        class="el-icon-arrow-right"
        style="margin-left: 10px; cursor: pointer"
        v-if="scrollFlag"
        @click="moveScroll(2)"
      ></i>
    </el-card>
    <div style="display:flex; justify-content: space-between; align-items: center; padding: 0 20px">
      <div style="display: flex;">
        <el-input style="width:200px;margin-right:10px" v-model="serarchTxt" placeholder="请输入需求名称" size="small" clearable></el-input>
        <el-input style="width:200px;margin-right:10px" v-model="workType" placeholder="请输入工作类型" size="small" clearable></el-input>
        <!-- <el-select style="width:200px" size="small" v-model="workStatus" placeholder="请选择工作状态">
          <el-option
            v-for="item in workStatusList"
            :key="item.code"
            :label="item.label"
            :value="item.code">
          </el-option>
        </el-select> -->
        <el-button size="small" type="primary" style="margin-left:10px;" @click="toSearch">搜索</el-button>
      </div>
    <div >
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        @click="setSuccess"
        >批量设置{{ this.myStatus == 1 ? "已" : "未" }}完成</el-button
      >
    </div>
    </div>
    <div
      class="div-box"
      style="padding: 0 20px"
    >
    <!-- <div
      class="div-box"
      v-loading="vloading"
      element-loading-text=""
      style="padding: 0 20px"
    > -->
      <tableBody
        ref="myTableBody"
        :diyHeight="'calc(100vh - 250px)'"
        :tableNameList="workSpaceName"
        :tableData="tableData"
        :controller="tableController"
        @handleSelectionChange="handleSelectionChange"
        @sortChange="changeSort"
      >
        <!-- <template slot="status" slot-scope="list">
            <span v-if="list.scope.row.status==1">未分配</span>
            <span v-else-if="list.scope.row.status==2" style="color: #E6A23C">进行中</span>
            <span v-else-if="list.scope.row.status==3" style="color: #E6A23C">进行中</span>
            <span v-else-if="list.scope.row.status==4" style="color: green">已完成</span>
            <span v-else-if="list.scope.row.status==5" style="color: red">已中止</span>
            <span v-else>--</span>
        </template> -->
        <template slot="demandJobStatus" slot-scope="list">
          <el-dropdown
            trigger="click"
            @command="getCurrentDrop(arguments, list.scope.row)"
          >
            <span class="el-dropdown-link">
              <span
                v-if="list.scope.row.demandJobStatus == 1"
                style="color: green"
                >进行中</span
              >
              <span v-else-if="list.scope.row.demandJobStatus == 2"
                >已完成</span
              >
              <!-- <span
                v-else-if="list.scope.row.demandJobStatus == 3"
                style="color: red"
                >已中止</span> -->
              <span v-else>--</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">进行中</el-dropdown-item>
              <el-dropdown-item command="2">已完成</el-dropdown-item>
              <!-- <el-dropdown-item command="3">已中止</el-dropdown-item> -->
              <!-- <el-dropdown-item command="3">已终止</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template slot="control" slot-scope="list">
          <el-button
            @click="handleDetail(list.scope.row)"
            type="text"
            size="small"
            >查看详情</el-button
          >
        </template>
      </tableBody>
      <pagination
        :pageSize="pagesize"
        :currentPage="currentPage"
        :pageTotal="pageTotal"
        :isPages="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { workSpaceName } from "@/utils/tableColumn";
import * as api from "./api";
export default {
  data() {
    return {
      workSpaceName,
      tableData: [],
      tempTableData: [],
      allTableData: [],
      multipleSelection: [],
      tableController: {
        isActive: true,
        selection: true,
        index: true,
        width: 100,
        rowKey: "",
      },
      // vloading: false,
      currentUser: {},
      myStatus: "1",
      projectList: [],
      currentProject: "",
      pagesize: 10,
      currentPage: 1,
      pageTotal: 10,
      listAll: [],
      cacheObj: {},
      isMounted: false,
      scrollFlag: false,
      serarchTxt: '',
      workType:'',
      workStatus:'',
      searchData: [],
      workStatusList:[{code:1,label:'进行中'},{code:2,label:'已完成'},{code:3,label:'已中止'}],
      cacheSearch:[]
    };
  },
  watch: {
    "$route.query": function () {
      if (this.$route.query.fresh == 1) {
        let newQuery = JSON.parse(JSON.stringify(this.$route.query)); // 深拷贝
        delete newQuery.fresh;
        this.$router.replace({ query: newQuery });
        this.$router.go(0);
      }
    },
  },
  created() {
    if (this.getQueryString("auth_code")) {
      let auth = this.getQueryString("auth_code");
      let state = this.getQueryString("state");
      this.$router.push({
        path: "/system-manage/other-authorization/index",
        query: { auth_code: auth, state },
      });
    }
  },
  methods: {
    toSearch() {
      if((this.serarchTxt == '' || this.serarchTxt.trim() == '') && (this.workType == '' || this.workType.trim() == '') && !this.workStatus) {
        this.searchData = this.allTableData;
        this.pageTotal = this.allTableData.length;
        this.handleCurrentChange(1);
        return
      }
      this.searchData = this.allTableData.filter(item => {
        let statusFlag = true
        if(this.workStatus){
          statusFlag = item.demandJobStatus == this.workStatus
        }
        return item.name.indexOf(this.serarchTxt) != -1 && item.jobName.indexOf(this.workType) != -1 && statusFlag
      })
      this.currentPage = 1;
      this.pageTotal = this.searchData.length;
      this.tableData = this.searchData.slice(0,this.pagesize)
    },
    changeSort(e) {
      this.currentPage = 1;
      if (!e.column.order) {
        console.log(111);
        this.allTableData.sort((a, b) => {
          return (
            new Date(a.createTime).getTime() - new Date(b.createTime).getTime()
          );
        });
        console.log(this.allTableData);
        this.tableData = this.allTableData.slice(0, this.pagesize);
        return
      }
      if (
        e.column.property == "createTime" ||
        e.column.property == "planStartTime" ||
        e.column.property == "planEndTime"
      ) {
        if (e.column.order == "descending") {
          this.allTableData.sort((a, b) => {
            return (
              new Date(a.createTime).getTime() -
              new Date(b.createTime).getTime()
            );
          });
          this.tableData = this.allTableData.slice(0, this.pagesize);
        } else if (e.column.order == "ascending") {
          this.allTableData.sort((a, b) => {
            return (
              new Date(b.createTime).getTime() -
              new Date(a.createTime).getTime()
            );
          });
          this.tableData = this.allTableData.slice(0, this.pagesize);
        }
      } else if(e.column.property == "priority") {
        if (e.column.order == "descending") {
          this.allTableData.sort((a, b) => {
            return b.priority - a.priority;
          });
          this.tableData = this.allTableData.slice(0, this.pagesize);
        } else if (e.column.order == "ascending") {
          this.allTableData.sort((a, b) => {
            return a.priority - b.priority
          });
          this.tableData = this.allTableData.slice(0, this.pagesize);
        }
      } else {
        if (e.column.order == "descending") {
          this.allTableData.sort((a, b) => {
            return a.jobName.charCodeAt() - b.jobName.charCodeAt();
          });
          this.currentPage = 1;
          this.tableData = this.allTableData.slice(0, this.pagesize);
        } else if (e.column.order == "ascending") {
          this.allTableData.sort((a, b) => {
            return b.jobName.charCodeAt() - a.jobName.charCodeAt();
          });
          this.tableData = this.allTableData.slice(0, this.pagesize);
        }
      }
    },
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    handleSelectionChange(val) {
      // 复选框选中操作
      this.multipleSelection = val;
    },
    handleDetail(e) {
      this.$router.push({
        path: "/project-manage/demand-manage/demandDetail",
        query: {
          id: e.id,
          parent_id: e.demandModuleId,
          projectVersionId: e.projectVersionId,
          projectId: this.currentProject,
        },
      });
    },
    // test(){
    //   console.log('test',this.$refs.scrollBar.scrollLeft,this.$refs.scrollBar.scrollWidth,this.$refs.scrollBar.clientWidth,this.computedScrollFlag().then(res=>{
    //     console.log('promise',res);
    //     this.scrollFlag = res
    //   }));
    // },
    computedScrollFlag() {
      return new Promise((resolve, reject) => {
        if (this.isMounted) {
          setTimeout(() => {
            resolve(
              this.$refs.scrollBar.scrollWidth >
                this.$refs.scrollBar.clientWidth
            );
          }, 100);
        } else resolve(false);
      });
    },
    moveScroll(e) {
      if (e == 1) {
        this.$refs.scrollBar.scrollLeft -= 100;
      } else if (e == 2) {
        this.$refs.scrollBar.scrollLeft += 100;
      }
    },
    handleCurrentChange(e) {
      console.log(111);
      //这里进行页面请求

      // this.cacheObj = Object.assign({},this.cacheObj)
      // this.$set(this.cacheObj,this.currentPage,this.multipleSelection)
      // console.log(this.multipleSelection,this.cacheObj)
      this.currentPage = e;
      this.tableData = this.allTableData.slice(
        this.pagesize * (e - 1),
        this.pagesize * e
      );
    },
    handleSizeChange(e) {
      // this.cacheObj = Object.assign({},this.cacheObj)
      // this.$set(this.cacheObj,this.currentPage,this.multipleSelection)
      this.currentPage = 1;
      this.pagesize = e;
      this.tableData = this.allTableData.slice(0, this.pagesize);
    },
    handleCommand(e) {
      console.log(e);
      this.myStatus = e;
      this.currentPage = 1;
      this.computedScrollFlag().then((res) => {
        // console.log('promise',res);
        this.scrollFlag = res;
      });
      this.getMyProject();
    },
    getCurrentDrop(e, obj) {
      console.log(e[0], obj);
      if (e[0] == obj.demandJobStatus) {
        return;
      }
      let list = [];
      list.push(obj.demandJobId);
      let params = {
        status: e[0],
        demandJobIdList: list,
      };
      console.log(params);
      api.batchSetEmployeeRelateDemandStatus(params).then((res) => {
        if (res.code === 1000) {
          this.$message.success(`操作成功`);
          this.getMyProject();
        }
      });
      // obj.missonStatus = e[0]
    },
    getCurrentProject(e) {
      this.currentProject = e.projectId;
      this.currentPage = 1;
      this.getMyTable();
    },

    getMyProject() {
      let params = {
        size: -1,
        relateStatus: this.myStatus,
      };
      api.pageProjectDemand(params).then((res) => {
        this.projectList = res.data.records;
        this.tableData = [];
        if (this.projectList.length != 0) {
          this.getCurrentProject(this.projectList[0]);
        }
      });
    },
    setSuccess(e) {
      // console.log(this.cacheObj)
      // if(Object.keys(this.cacheObj).length ==0 && this.multipleSelection.length == 0){
      //   this.$message.warning(`请先选择要设置的需求项`);
      //   return
      // } else {
      //   let key = Object.keys(this.cacheObj)
      //   key.forEach(v=>{
      //     if(this.currentPage != v){
      //       // console.log('Jjj',this.cacheObj[v]);
      //       this.cacheObj[v].forEach(item=>{
      //         this.multipleSelection.push(item)
      //       })
      //     }
      //   })

      // }
      // if(this.multipleSelection.length === 0){
      //   this.$message.warning(`请先选择要设置的需求项`);
      //   return
      // }
      let params = {
        status: this.myStatus == 1 ? "2" : "1",
        demandJobIdList: this.multipleSelection.map((item) => item.demandJobId),
      };
      console.log("multipleSelection", this.multipleSelection);
      api
        .batchSetEmployeeRelateDemandStatus(params)
        .then((res) => {
          if (res.code === 1000) {
            this.$message.success(`操作成功`);
            this.getMyProject();
          }
        })
        .finally(() => {
          this.multipleSelection = [];
          this.cacheObj = {};
          this.$refs.myTableBody.$refs.tableBody.clearSelection();
        });
    },
    getMyTable() {
      let params = {
        size: -1,
        current: this.currentPage,
        projectId: this.currentProject,
        relateStatus: this.myStatus,
      };
      // this.vloading = true;
      api.pageMyTableDemand(params).then((res) => {
        console.log(res);
        this.pageTotal = res.data.records?res.data.records.length:0//res.data.total;
        this.allTableData = res.data.records;
        if (this.tempTableData.length == 0) {
          this.tempTableData = res.data.records;
        }
        this.tableData = this.allTableData.slice(0, this.pagesize);
        // this.vloading = false;

        // this.$nextTick(() => {
        //   // this.$refs.myTableBody.toggleRowSelection(this.tableData[2]);
        //   if (Object.keys(this.cacheObj).length != 0) {
        //     let list = this.cacheObj[this.currentPage];
        //     let newlist = [];

        //     if (list && list.length != 0) {
        //       list.forEach((row) => {
        //         if (this.tableData.find((v) => v.id == row.id).id) {
        //           newlist.push(this.tableData.find((v) => v.id == row.id));
        //         }
        //       });
        //       newlist.forEach((row) => {
        //         // console.log('进来了',row);
        //         this.$refs.myTableBody.toggleRowSelection(row);
        //       });
        //     }
        //   }
        // });
      });
    },
  },
  mounted() {
    if (this.$route.query.fresh == 1) {
      let newQuery = JSON.parse(JSON.stringify(this.$route.query)); // 深拷贝
      delete newQuery.fresh;
      this.$router.replace({ query: newQuery });
      this.$router.go(0);
    }
    this.isMounted = true;
    this.computedScrollFlag().then((res) => {
      // console.log('promise',res);
      this.scrollFlag = res;
    });
    // console.log('asd',this.$refs.scrollBar.scrollWidth , this.$refs.scrollBar.clientWidth);
    this.currentUser = JSON.parse(localStorage.currentUser);
    this.getMyProject();
    // console.log(JSON.parse(localStorage.currentUser))
    window.addEventListener('resize', (e)=>{
      if(this.$refs.myTableBody){
        this.$refs.myTableBody.headerDragent()
        console.log('resize');
      }
    });
  },
  beforeDestroy(){
    window.removeEventListener('resize', (e)=>{
      if(this.$refs.myTableBody){
        this.$refs.myTableBody.headerDragent()
        console.log('resize');
      }
    })
  },
};
</script>

<style scoped>
.div-box >>> .el-loading-spinner .circular {
  width: 2px;
  height: 2px;
  animation: loading-rotate 2s linear infinite;
  display: none;
}
.div-box >>> .el-loading-spinner {
  background: url(../../assets/loading.gif) no-repeat;
  background-size: 200px 200px;
  background-color: rgba(255, 255, 255);
  /* width: 50%;
  height: 50%; */
  width: 200px;
  height: 200px;
  position: relative;
  top: 40%;
  left: 45%;
}
.filter-item {
  margin: 10px 0;
}
.top-list {
  padding: 10px 0;
}
/* .top-tool{
    width: 100%;
    position: fixed;
    top: 60px;
    left: 0;
  } */
.top-tool >>> .el-card__body {
  display: flex;
  align-items: center;
  padding-left: 50px;
  padding-right: 50px;
  /* padding-top: 15px;
    padding-bottom: 15px; */
}
.project-list {
  display: flex;
  flex: 1;
  overflow: hidden;
  /* box-shadow: 0px 0px 1px 1px rgba(0, 0, 0, 0.2); */
}
.ml50 {
  margin-left: 50px;
}
.project-item {
  margin: 5px 20px;
  cursor: pointer;
  white-space: nowrap;
}
.highLight {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/my-workbench/MyWorkbench.vue